import "../../../../src/pages/css/styles.css";
import * as React from 'react';
export default {
  React
};